import { useContext } from "react";
import { useAddresses } from "../../../Addresses/useAddresses";
import { UpdateOrderDeliveryPickupModalContext } from "../deliveryModalUtils/UpdateOrderDeliveryPickupModalContext";
import { onModalClose } from "../deliveryModalUtils/helpers";
import { PaymentFormContext } from "../../../Shared/components/PaymentForm/PaymentFormContext";
/**
 *
 * @param orderId
 * @param refetchOrders
 * @param updateFunction
 * @returns
 */
export const useUpdateOrderDeliveryModal = (props) => {
    var _a;
    const { currentOrderId, currentOrderNumber, currentOrderStatus, currentOrderInfo, flowSku, initTabProps, programId, refetchOrders, setShowModal, showModal, subscriptionLinkId, updateFunction, formId, } = props;
    const { setNewAddressData } = useContext(UpdateOrderDeliveryPickupModalContext);
    const { setBalance } = useContext(PaymentFormContext);
    const addressesData = useAddresses(currentOrderId, programId, undefined, subscriptionLinkId);
    const { addressState: { loading, usesLocation, usesZipCodes }, } = addressesData;
    const onClose = onModalClose(setNewAddressData, setBalance, setShowModal);
    const componentProps = {
        addressesData,
        flowSku,
        initTabProps,
        loading,
        onClose,
        orderId: currentOrderId,
        orderInfo: currentOrderInfo,
        orderNumber: currentOrderNumber,
        orderStatus: currentOrderStatus,
        programId,
        refetchOrders,
        setBalance,
        setNewAddressData,
        setShowModal,
        showAddresses: usesLocation || usesZipCodes || ((_a = initTabProps === null || initTabProps === void 0 ? void 0 : initTabProps.isCheckout) !== null && _a !== void 0 ? _a : false),
        showModal,
        updateFunction,
        formId,
    };
    return componentProps;
};
